import React, { useState, useMemo, useEffect } from 'react'
import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout'
import EmpresasTable from '../../components/Empresas/EmpresasTable'
import EmpresaModal from '../../components/Empresas/EmpresaModal'
import EmpresaCreateModal from '../../components/Empresas/EmpresaCreateModal'
import useEmpresas from '../../hooks/useEmpresas'
import { useMantenedores } from '../../context/MantenedoresContext'
import { Button, Spinner } from 'react-bootstrap'

const Empresas = () => {
    const {
        user,
        empresas,
        tiposDocumento,
        loading,
        modalLoading,
        error,
        selectedEmpresa,
        fetchEmpresaById,
        handleUpdateEmpresa,
        handleCreateEmpresa,
        handleDeleteEmpresa,
        fetchEmpresas
    } = useEmpresas()

    const { userPermissions } = useMantenedores()
    const [showModal, setShowModal] = useState(false)
    const [showCreateModal, setShowCreateModal] = useState(false)
    const [selectedId, setSelectedId] = useState(null)
    const [createLoading, setCreateLoading] = useState(false)

    // Permisos del usuario para empresas
    const empresaPermisos = useMemo(() => {
        return userPermissions?.modules?.empresas || {}
    }, [userPermissions])

    // Handler para abrir modal de detalles

    const handleRowClick = empresa => {
        setSelectedId(empresa.id)
        setShowModal(true)
    }

    // Handler para cerrar modal de detalles
    const handleCloseModal = () => {
        setShowModal(false)
        setSelectedId(null)
    }

    // Handler para actualizar empresa
    const handleUpdate = async (id, data) => {
        const result = await handleUpdateEmpresa(id, data)
        // Solo recargar la tabla después de editar si fue exitoso
        if (result && result.success) {
            fetchEmpresas()
        }
        return result
    }

    // Handler para crear empresa
    const handleCreate = async data => {
        setCreateLoading(true)
        const result = await handleCreateEmpresa(data)
        setCreateLoading(false)
        
        // Solo recargar la tabla si fue exitoso
        if (result && result.success) {
            setShowCreateModal(false)
            fetchEmpresas()
        }
        
        return result
    }

    // Handler para eliminar/deshabilitar empresa
    const handleDelete = async id => {
        const response = await handleDeleteEmpresa(id)
        if (response && response.success) {
            // Recargar la tabla después de deshabilitar
            fetchEmpresas()
        }
        return response
    }

    return (
        <SimpleMantenedorLayout
            mantenedorId="empresas"
            title="Mantenedor de Empresas"
            subtitle="Gestión de empresas del sistema"
            iconColor="#007bff"
            breadcrumbs={[{ label: 'Empresas' }]}
            showBackButton={false}>
            <div className="empresas-container" style={{ position: 'relative' }}>
                {/* Botón crear empresa si tiene permisos */}
                {(empresaPermisos.canCreate || empresaPermisos.canAdmin) && (
                    <div style={{ position: 'absolute', right: 0, top: 0, zIndex: 2 }}>
                        <Button variant="primary" onClick={() => setShowCreateModal(true)}>
                            + Crear Empresa
                        </Button>
                    </div>
                )}

                {/* Tabla de empresas */}
                <div style={{ marginTop: empresaPermisos.canCreate || empresaPermisos.canAdmin ? '48px' : '0' }}>
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : error ? (
                        <div className="alert alert-danger">{error}</div>
                    ) : (
                        <EmpresasTable empresas={empresas} onRowClick={handleRowClick} />
                    )}
                </div>

                {/* Modal de detalles y edición */}
                <EmpresaModal
                    user={user}
                    show={showModal}
                    onHide={handleCloseModal}
                    empresaId={selectedId}
                    permisos={empresaPermisos}
                    fetchEmpresa={fetchEmpresaById}
                    empresa={selectedEmpresa}
                    onUpdate={handleUpdate}
                    onDelete={handleDelete}
                    loading={modalLoading}
                />

                {/* Modal de creación */}
                <EmpresaCreateModal
                    show={showCreateModal}
                    onHide={() => setShowCreateModal(false)}
                    onCreate={handleCreate}
                    loading={createLoading}
                    tiposDocumento={tiposDocumento}
                />
            </div>
        </SimpleMantenedorLayout>
    )
}

export default Empresas
